<template>
<div class="container">
  <slot></slot>
 </div>
</template>

<script>
export default {
  name: 'oddEvenGrid',
}
</script>

<style lang="scss" scoped>
.odd-even-grid{
  display: flex;
  margin: 0 auto;
  max-width: 1312px;
  margin-top: layout-val-64(1);
    .img-box, .text-box{
      flex:1;

      img{
        max-width: 460px;
        width: 100%;
        max-height: 350px;
        border-radius: 15px;
      }

      .float-right{
        float:right;
      }
    }
    .text-box{
      position: relative;
      .content{
         @include pos-center($axis: 'y');
      }
    }
}
.last-item{
  padding-bottom: layout-val-64(2);
}

.padding-left{
  padding-left: layout-val-8(2);
}

.padding-right{
  padding-right: layout-val-8(2);
}

@media screen and (max-width: 640px) {
  .odd-even-grid{
    flex-direction: column;
    margin-top:layout-val-8(8);
  }
 
  .odd-even-grid .text-box .content{
    position: relative;
    top:0;
    transform: none;
  }

  .odd{
    flex-direction: column-reverse;
  }

}
</style>